export default __webpack_public_path__ + "static/media/caret.cfb49c17.svg";